import React, { useState } from "react";
import "./RegionCard.scss";
import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import { notify, ToastType } from "utils/Toast";
import { ValidationErrorMessages } from "utils/Error";

interface Props {
  id: string;
  title: string;
  keyNumber: string;
  maxInput: string;
  data: any;
  reSort: () => void;
}

const RegionCard: React.FC<Props> = ({
  id,
  title,
  keyNumber,
  maxInput,
  data,
  reSort,
}) => {
  const [value, setValue] = useState<string>(keyNumber + 1);
  const [allowToCallApi, setAllowToCallApi] = useState<boolean>(true);

  const changeSort = (e: React.ChangeEvent<HTMLInputElement>) => {
    
    if (e.target.value < maxInput + 1 && parseInt(e.target.value) > 0) {
      setValue(e.target.value);

      if (
        e.target.value !== null &&
        e.target.value !== undefined &&
        e.target.value !== ""
      ) {
        if (allowToCallApi) {
          setTimeout(() => {
            const NewObj = {
              currentOrderId: e.target.value,
              currentRegionId: data[parseInt(e.target.value) - 1].id,
              startOrderId: keyNumber + 1,
              startRegionId: id,
            };
            Axios(AxiosMethodEnum.post,Axios_Route.EDIT_REGION_SORT, NewObj).then(
              ({ response, success }) => {
                if (success) {
                  notify(
                    ValidationErrorMessages.SUCCESS.REGION_SORT_EDITED,
                    ToastType.success
                  );
                } else {
                  notify(
                    ValidationErrorMessages.ERRORS.TRY_AGAIN,
                    ToastType.error
                  );
                }
                reSort();
                setAllowToCallApi(true)
              }
            );
          }, 1000);
        }
        setAllowToCallApi(false)
      }
    }
  };

  return (
    <div className="card-container">
      <p className="title">{title}</p>
      <input
        type={"number"}
        min={1}
        max={maxInput}
        value={value}
        onChange={changeSort}
        onFocus={(e) => e.target.select()}
      />
    </div>
  );
};

export default RegionCard;
